Immutable = require 'seamless-immutable'
{ AUTHENTICATED_STUDENT, AUTHENTICATING_STUDENT, CREATED_STUDENT, CREATING_STUDENT, DELETED_STUDENT, DELETING_STUDENT, FETCHED_STUDENT, FETCHED_STUDENTS, FETCHING_STUDENT, FETCHING_STUDENTS, IMPORTING_STUDENTS, IMPORTED_STUDENTS, REMOVED_STUDENT_FROM_CLASSROOM, REMOVING_STUDENT_FROM_CLASSROOM, UPDATED_STUDENT, UPDATING_STUDENT } = require '../actions/students'

baseState = Immutable
	authenticated: null
	importError: null
	isAuthenticating: false
	isCreating: false
	isDeleting: false
	isFetching: false
	isImporting: false
	isRemovingFromClassroom: false
	isUpdating: false
	list: []
	pages: 0
	selected: null

students = (state = baseState, action) ->
	doing = (inProgressState) ->
		state.set inProgressState, true

	did = (inProgressState) ->
		state.set inProgressState, false

	switch action.type
		when AUTHENTICATING_STUDENT
			state = doing 'isAuthenticating'
		when AUTHENTICATED_STUDENT
			state = did 'isAuthenticating'
			unless action.error
				state = state.set 'authenticated', action.payload.student
		when CREATING_STUDENT
			state = doing 'isCreating'
		when CREATED_STUDENT
			state = did 'isCreating'
		when DELETING_STUDENT
			state = doing 'isDeleting'
		when DELETED_STUDENT
			state = did 'isDeleting'
		when FETCHING_STUDENT
			state = doing 'isFetching'
		when FETCHED_STUDENT
			state = did 'isFetching'
			unless action.error
				state = state.set 'selected', action.payload.student
		when FETCHING_STUDENTS
			state = doing 'isFetching'
		when FETCHED_STUDENTS
			state = did 'isFetching'
			unless action.error
				state = state.set 'list', action.payload.list
				state = state.set 'pages', action.payload.pages
		when IMPORTING_STUDENTS
			state = state.set 'importError', null
			state = state.set 'isImporting', true
		when IMPORTED_STUDENTS
			state = state.set 'isImporting', false
			if action.error
				state = state.set 'importError', action.payload.error
		when REMOVING_STUDENT_FROM_CLASSROOM
			state = doing 'isRemovingFromClassroom'
		when REMOVED_STUDENT_FROM_CLASSROOM
			state = did 'isRemovingFromClassroom'
			state = state.set 'list', action.payload.list unless action.error
		when UPDATING_STUDENT
			state = doing 'isUpdating'
		when UPDATED_STUDENT
			state = did 'isUpdating'
	state

module.exports = students



// WEBPACK FOOTER //
// ./frontend/olos/js/reducers/students.coffee